<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <!-- MOBILE VIEW (Fintech Style) -->
    <div class="content d-lg-none mob-kios-list">
        <!-- Header & Search -->
        <div class="px-2 mb-4">
           <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center gap-3">
                 <a href="javascript:void(0);" @click="router.push('/dashboard')" class="btn-back-mob shadow-sm">
                    <vue-feather type="arrow-left" size="20"></vue-feather>
                 </a>
                 <h4 class="fw-bold mb-0">Kios SSP</h4>
              </div>
              <button v-if="$hasPermission('ssp', 'members', 'create')" @click="router.push('/people/add-member')" class="btn btn-success-circle shadow-sm">
                 <vue-feather type="plus" size="20"></vue-feather>
              </button>
           </div>
           
           <div class="search-input-mob shadow-xs">
              <vue-feather type="search" size="18" class="text-muted"></vue-feather>
              <input type="text" v-model="searchQuery" placeholder="Cari Kios..." class="border-0 bg-transparent w-100 ms-2" />
           </div>
        </div>

        <!-- Kios List Cards -->
        <div class="px-2 pb-5">
           <div v-if="filteredMembers.length > 0">
              <div 
                v-for="kios in filteredMembers" 
                :key="'mob-kios-'+kios.id" 
                class="mob-kios-card mb-4 p-0 bg-white"
                @click="router.push('/people/kios-details/' + kios.id)"
                style="cursor: pointer;"
              >
                 <div class="px-3 pt-3 pb-1 d-flex justify-content-between align-items-center">
                    <span v-if="kios.is_new" class="badge bg-success rounded-pill smallest px-2 py-1 uppercase">DATA BARU</span>
                    <span v-else></span>
                    <div class="d-flex gap-2">
                       <button v-if="$hasPermission('ssp', 'members', 'edit')" @click.stop="router.push('/people/edit-member/' + kios.id)" class="btn-action-lite text-primary">
                          <vue-feather type="edit-3" size="14"></vue-feather>
                       </button>
                       <button v-if="$hasPermission('ssp', 'members', 'delete')" @click.stop="showConfirmation(kios.id)" class="btn-action-lite text-danger">
                          <vue-feather type="trash-2" size="14"></vue-feather>
                       </button>
                    </div>
                 </div>

                 <!-- Shop Info -->
                 <div class="px-3 pb-3 pt-1 bg-light-tint mx-2 rounded-4 mb-2">
                    <h6 class="fw-bold text-dark mb-1">{{ kios.nama_toko }}</h6>
                    <div class="d-flex justify-content-between">
                       <span class="smallest text-muted text-uppercase fw-bold">{{ kios.nama_member }}</span>
                       <span class="smallest text-success fw-bold">{{ kios.pendamping_nama }}</span>
                    </div>
                 </div>

                 <!-- Footer Info -->
                 <div class="px-3 pb-3">
                    <span class="smallest text-muted text-truncate d-block">{{ kios.alamat || 'Alamat tidak tersedia' }}</span>
                 </div>
              </div>
           </div>
           
           <!-- Empty State Mobile -->
           <div v-else class="text-center py-5">
              <div class="bg-light p-4 rounded-circle d-inline-block mb-3">
                 <vue-feather type="home" class="text-muted" size="40"></vue-feather>
              </div>
              <p class="text-muted small">Tidak ada data Kios ditemukan.</p>
           </div>
        </div>
    </div>

    <!-- DESKTOP VIEW (Untouched) -->
    <div class="content d-none d-lg-block">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Kios SSP</h4>
            <h6>Kelola Data Kios / Member SSP Anda</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"
              ><img src="@/assets/img/icons/pdf.svg" alt="img"
            /></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"
              ><img src="@/assets/img/icons/excel.svg" alt="img"
            /></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"
              ><i data-feather="printer" class="feather-printer"></i
            ></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"
              ><i data-feather="rotate-ccw" class="feather-rotate-ccw"></i
            ></a>
          </li>
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              id="collapse-header"
              ><i data-feather="chevron-up" class="feather-chevron-up"></i
            ></a>
          </li>
        </ul>
        <div v-if="$hasPermission('ssp', 'members', 'create')" class="page-btn">
          <button
            @click="router.push('/people/add-member')"
            class="btn btn-added"
            ><vue-feather type="plus-circle" class="me-2"></vue-feather>Tambah Kios</button>
        </div>
      </div>

      <!-- /member list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input 
                  type="text" 
                  placeholder="Cari Kios (Nama Pemilik/Nama Toko)..." 
                  class="dark-input" 
                  v-model="searchQuery"
                />
                <a href="javascript:void(0);" class="btn btn-searchset"
                  ><i data-feather="search" class="feather-search"></i
                ></a>
              </div>
            </div>
            <div class="search-path d-none d-md-block">
              <a
                class="btn btn-filter"
                id="filter_search"
                v-on:click="filter = !filter"
                :class="{ setclose: filter }"
              >
                <vue-feather type="filter" class="filter-icon"></vue-feather>
                <span><img src="@/assets/img/icons/closes.svg" alt="img" /></span>
              </a>
            </div>
            <div class="form-sort d-none d-md-flex">
              <vue-feather type="sliders" class="info-img"></vue-feather>
              <vue-select 
                :options="SortOptions" 
                v-model="sortOrder" 
                placeholder="Urutkan" 
                @select="sortOrder = $event.value"
              />
            </div>
          </div>
          <!-- /Filter -->
          <div
            class="card mb-0"
            :style="{ display: filter ? 'block' : 'none' }"
            id="filter_inputs"
          >
            <div class="card-body pb-3">
              <div class="row align-items-center">
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="input-blocks">
                    <vue-feather type="user" class="info-img"></vue-feather>
                    <vue-select
                      :options="pendampingOptions"
                      v-model="pendampingFilter"
                      placeholder="Pilih Pendamping"
                      @select="pendampingFilter = $event.value"
                    />
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-12">
                  <div class="input-blocks">
                    <a class="btn btn-filters" @click="resetFilters">
                      <vue-feather type="rotate-ccw" class="me-1" style="width: 14px;"></vue-feather>
                      Reset
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <div class="table-responsive">
            <a-table
              class="table datanew table-hover table-center mb-0"
              :columns="columns"
              :data-source="filteredMembers"
              :loading="loading"
              :key="state.members.length"
              :pagination="{
                pageSize: 5,
                showSizeChanger: false,
                position: ['bottomRight']
              }"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Kios'">
                  <div class="userimgname">
                    <router-link :to="'/people/kios-details/' + record.id">
                        <span v-if="record.is_new" class="badge badge-linesuccess mb-1">Data Baru</span><br v-if="record.is_new">
                        <strong>{{ record.nama_toko }}</strong><br>
                        <small class="text-muted">{{ record.nama_member }}</small>
                    </router-link>
                  </div>
                </template>



                <template v-else-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <a 
                        v-if="$hasPermission('ssp', 'members', 'edit')"
                        class="me-2 p-2" 
                        href="javascript:void(0);"
                        @click="openEditModal(record)"
                      >
                         <vue-feather type="edit" class="feather-edit"></vue-feather>
                      </a>
                      <a
                        v-if="$hasPermission('ssp', 'members', 'delete')"
                        class="confirm-text p-2"
                        @click="showConfirmation(record.id)"
                        href="javascript:void(0);"
                      >
                        <vue-feather type="trash-2" class="trash-2"></vue-feather>
                      </a>
                    </div>
                  </td>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    <!-- /member list -->
    </div>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
import { ref, computed, onMounted } from "vue";
import { useDataStore } from "@/store/dataStore";
import memberService from "@/services/memberService";
import Swal from "sweetalert2";

export default {
  components: {
  },
  setup() {
    const displayColumns = computed(() => {
      const baseColumns = [
        {
          title: "Kios / Nama",
          key: "Kios",
          sorter: {
            compare: (a, b) => a.nama_toko.localeCompare(b.nama_toko),
          },
        },
        {
          title: "Pendamping",
          dataIndex: "pendamping_nama",
          key: "Pendamping",
          sorter: {
            compare: (a, b) => (a.pendamping_nama || "").localeCompare(b.pendamping_nama || ""),
          },
        },
        {
          title: "Alamat",
          dataIndex: "alamat",
          key: "Alamat",
        },
      ];

      const userStr = localStorage.getItem('currentUser');
      const user = userStr ? JSON.parse(userStr) : null;
      const isAdmin = user?.role === 'admin';
      const perms = user?.permissions?.ssp?.members || [];
      
      if (isAdmin || perms.includes('edit') || perms.includes('delete')) {
        baseColumns.push({
          title: "Aksi",
          key: "action",
        });
      }
      
      return baseColumns;
    });
    const router = useRouter();
    const { state, refreshData, clearNewMemberId } = useDataStore();
    const loading = ref(false);

    const openAddModal = () => {
       router.push('/people/add-member');
    };

    const openEditModal = (member) => {
       router.push('/people/edit-member/' + member.id);
    };

    onMounted(async () => {
      // Hanya tampilkan loading jika data benar-benar kosong
      if (state.members.length === 0) {
        loading.value = true;
      }
      
      const hadNewMember = state.newMemberId !== null;
      
      // Load data di background tanpa menghapus data lama
      refreshData('members').finally(() => {
        loading.value = false;
        if (hadNewMember) {
           // delay sedikit agar mata user sempat melihat highlight
           setTimeout(() => clearNewMemberId(), 2000);
        }
      });

      // Juga pastikan pendamping terload untuk filter
      if (state.pendampings.length === 0) {
        refreshData('pendampings');
      }
    });
    
    const filter = ref(false);
    const searchQuery = ref("");
    const selectedMember = ref({});
    const pendampingFilter = ref(null);
    const sortOrder = ref("ASC");

    const pendampingOptions = computed(() => {
      return (state.pendampings || []).map(p => ({
        id: p.id,
        value: p.id,
        text: p.nama_pendamping
      }));
    });

    const resetFilters = () => {
        searchQuery.value = "";
        pendampingFilter.value = null;
    };

    // Filter di sisi client - gunakan state.members secara langsung untuk reaktivitas maksimal
    const filteredMembers = computed(() => {
      let result = [...(state.members || [])];
      
      // 1. Search Query
      if (searchQuery.value) {
        const query = searchQuery.value.toLowerCase();
        result = result.filter(item => 
          (item.nama_member && item.nama_member.toLowerCase().includes(query)) ||
          (item.nama_toko && item.nama_toko.toLowerCase().includes(query)) ||
          (item.alamat && item.alamat.toLowerCase().includes(query))
        );
      }

      // 2. Pendamping Filter
      if (pendampingFilter.value) {
        result = result.filter(item => item.pendamping_id == pendampingFilter.value);
      }

      // 3. Sorting
      result.sort((a, b) => {
        // Jika ada member baru, tetap di paling atas
        if (a.id === state.newMemberId) return -1;
        if (b.id === state.newMemberId) return 1;

        const nameA = (a.nama_toko || "").toLowerCase();
        const nameB = (b.nama_toko || "").toLowerCase();
        
        if (sortOrder.value === "ASC") {
          return nameA.localeCompare(nameB);
        } else {
          return nameB.localeCompare(nameA);
        }
      });

      // Mark new member flag manually after filtering/sorting
      return result.map(m => ({
        ...m,
        is_new: m.id === state.newMemberId
      }));
    });

    const showConfirmation = (id) => {
      Swal.fire({
        title: "Apakah Anda yakin?",
        text: "Data yang dihapus tidak dapat dikembalikan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, hapus!",
        cancelButtonText: "Batal",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await memberService.deleteMember(id);
            
            const toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            });

            toast.fire({
              icon: 'success',
              title: 'Kios telah berhasil dihapus'
            });

            await refreshData('members');
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Terjadi Kesalahan",
              text: "Gagal menghapus kios dari server",
              confirmButtonClass: "btn btn-danger",
            });
          }
        }
      });
    };

    return {
      filter,
      loading,
      filteredMembers,
      searchQuery,
      selectedMember,
      columns: displayColumns,
      showConfirmation,
      clearNewMemberId,
      state,
      resetFilters,
      pendampingFilter,
      sortOrder,
      pendampingOptions,
      router,
      openAddModal,
      openEditModal,
      SortOptions: [
        { id: 'ASC', value: 'ASC', text: 'ASC (A-Z)' },
        { id: 'DESC', value: 'DESC', text: 'DESC (Z-A)' }
      ]
    };
  },
};
</script>

<style scoped>
.mob-kios-list {
  padding-top: 15px !important;
  background: #fdfdfd;
}

.btn-back-mob {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e293b;
  border: 1px solid #f1f5f9;
  transition: all 0.2s;
}
.btn-back-mob:active {
  transform: scale(0.9);
  background: #f8fafc;
}

.btn-success-circle {
  width: 44px;
  height: 44px;
  background: #029147;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}

.search-input-mob {
  background: white;
  padding: 12px 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  border: 1px solid #f1f5f9;
}

.mob-kios-card {
  background: white;
  border-radius: 24px;
  border: none !important;
  box-shadow: 0 10px 25px rgba(0,0,0,0.06);
  overflow: hidden;
  transition: all 0.2s ease;
}

.mob-kios-card:active { 
  transform: translateY(2px) scale(0.98); 
  box-shadow: 0 5px 15px rgba(0,0,0,0.04);
}

.btn-action-lite {
  background: #f8fafc;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.btn-action-lite:active { transform: scale(0.9); }

.bg-light-tint { background: #f8fafc; }

.uppercase { text-transform: uppercase; letter-spacing: 0.5px; }
.smallest { font-size: 11px; }

@media (max-width: 991.98px) {
  .page-header { display: none !important; }
}

.btn-added {
    background-color: #000;
    color: #fff;
    border-radius: 8px;
    font-weight: bold;
}
.btn-added:hover {
    background-color: #333;
    color: #fff;
}
</style>
